module.exports = __webpack_public_path__ + "img/ES0234.aa9f99a5.png";